import React, { useEffect, useState } from 'react';
import LoginForm from './loginForm';
import rovquest_logo from 'assets/images/rovquest_logo_primary.png';
import MainOnboard from './mainOnboard';
import jpFlag from '../../assets/icons/jp_flag.svg';
import enFlag from '../../assets/icons/en_flag.svg';
import i18n from 'i18next';

const Login: React.FC = () => {
  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'jp'
  );

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  return (
    <div className="flex min-h-screen">
      <img
        src={rovquest_logo}
        alt="Rovquest Logo"
        className="fixed top-8 left-6 w-64 h-16"
      />

      <div className="fixed top-8 right-1/2 mr-20 p-1 border rounded-md flex items-center space-x-2">
        {[
          { lang: 'jp', label: '日本', flag: jpFlag },
          { lang: 'en', label: 'English', flag: enFlag },
        ].map(({ lang, label, flag }) => (
          <button
            key={lang}
            onClick={() => handleLanguageChange(lang)}
            className={`px-3 py-2 rounded-md flex items-center ${
              language === lang
                ? 'bg-primary/300 text-white'
                : 'bg-gray-300 text-neutral/200'
            }`}
          >
            <img
              src={flag}
              alt={`${label} Flag`}
              className="w-5 h-5 rounded-full mr-2"
            />
            {label}
          </button>
        ))}
      </div>

      <div className="flex-1 flex items-center">
        <LoginForm />
      </div>

      <MainOnboard />
    </div>
  );
};

export default Login;
